// extracted by mini-css-extract-plugin
export default {"nav-item":"SettingNavItem_nav-item__zxSBM","focus":"SettingNavItem_focus__v8aFL","active":"SettingNavItem_active__9Eexx"};